export const FILLER = 2;
export const APPLIED_PANEL = 3;
const DRAWER_FACE = 10;

// this basically means these 3 types of products can have profile applied to them
// not that they have door on them.
export const checkHasDoor = (productType: number) => {
    return [FILLER, APPLIED_PANEL, DRAWER_FACE].includes(productType);
};
